import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export const PROJECT_STAGES = [
  { key: "ENQUIRY", label: "Enquiry" },
  { key: "DESIGN", label: "Design" },
  { key: "PREVIEW", label: "Preview" },
  { key: "QUOTE", label: "Quote" },
  { key: "ORDER", label: "Order" },
  { key: "INSTALLATION", label: "Installation" },
];

/**
 * doneUpTo: index (0-based) of the furthest completed stage. -1 means nothing done.
 */
export default function ProjectStepper({ doneUpTo = 0 }) {
  return (
    <ol className="flex items-start w-full overflow-x-auto pb-1" data-testid="project-progress-stepper">
      {PROJECT_STAGES.map((stage, idx) => {
        const isDone = idx <= doneUpTo;
        const isCurrent = idx === doneUpTo + 1;
        const isLast = idx === PROJECT_STAGES.length - 1;
        return (
          <li
            key={stage.key}
            aria-current={isCurrent ? "step" : undefined}
            className={cn("relative flex flex-col items-center min-w-[84px]", !isLast && "flex-1")}
          >
            {!isLast && (
              <span
                aria-hidden="true"
                className={cn("absolute top-[15px] left-[calc(50%+22px)] right-[calc(-50%+22px)] h-0.5 rounded-full", idx < doneUpTo ? "bg-primary" : "bg-border")}
              />
            )}
            <span
              data-testid={`stepper-stage-${stage.key.toLowerCase()}`}
              className={cn(
                "relative h-8 w-8 rounded-full flex items-center justify-center text-xs font-semibold transition-colors duration-300",
                isDone && "bg-primary text-primary-foreground",
                isCurrent && "bg-accent text-accent-foreground ring-4 ring-accent/15 hi-animate-pulse-scale",
                !isDone && !isCurrent && "bg-card text-muted-foreground border border-border",
              )}
            >
              {isDone ? <Check className="h-4 w-4" strokeWidth={2.5} /> : idx + 1}
            </span>
            <span
              className={cn(
                "mt-2 text-xs whitespace-nowrap",
                isDone && "text-foreground font-medium",
                isCurrent && "text-accent font-semibold",
                !isDone && !isCurrent && "text-muted-foreground",
              )}
            >
              {stage.label}
              {isDone && <span className="sr-only"> (done)</span>}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
